module.exports = __webpack_public_path__ + "static/img/signSuccess.07d2957e.png";